import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { CustomError, DialogService } from '@vectronic/util';
import { ErrorDialogComponent } from '../components/error-dialog-component/error-dialog.component';

@Injectable({ providedIn: 'root' })
export class DialogErrorHandler implements ErrorHandler {
  private dialogService = inject(DialogService);
  private ngZone = inject(NgZone);

  handleError(error: any) {
    console.error(error);
    let msg: string;
    if (error instanceof HttpErrorResponse) {
      let append = '';
      if (typeof error.error === 'string') {
        append = error.error;
      } else if (error.error) {
        append =
          'message' in error.error ? error.error.message : JSON.stringify(error.error, null, 2);
      }
      msg = error.message + '\n\n' + append;
      this.openDialog(msg || 'Undefined client error');
    } else if (error instanceof CustomError) {
      this.openDialog(error.message);
    }
  }

  private openDialog(message: string) {
    this.ngZone.run(() => {
      this.dialogService.openWide(ErrorDialogComponent, { data: { message } });
    });
  }
}
